/* 全局项目配置
 */
export default {
  tempOpen: window.g.tempOpen, // 临时打开假视频
  appName: window.g.appName, // 应用名
  webSocketHostAR: window.g.webSocketHostAR, // 视频流
  appShortName: window.g.appShortName, // 应用名简称
  devHost: window.g.devHost, // 开发阶段的后端服务主机
  prodHost: window.g.prodHost, // 生产环境的主机
  userInitPassword: '888888', // 新建用户或重置用户时的初始密码
  userHasPermission: true, // 是否启用权限管理 , 在测试阶段没有加入权限管理的时候,全部不启用,则默认所有功能都可以使用
  permbuttonShowOrDisabled: 1, // 权限按钮在无权限条件下的状态？ 0为不显示，1为禁用状态
  dataTablePaginationPosition: 'top', // 数据表格分页控件定位位置 ，top表格之上，bottom 表格之下
  dataTablePaginationPageSize: 10, //  数据表格分 页大小
  cameraUrl: window.g.cameraUrl //视频流,球机控制
}


// WEBPACK FOOTER //
// ./src/web.config.js